import React from 'react';
import {Link} from 'react-router-dom'
import HomeCounter from '../hometwo/HomeCounter'
import Slider from 'react-slick'

function AdoptionSlider() {
  const settings = {
    dots: false,
	infinite: true,
	speed: 1000,
	autoplay: true,
	arrows: false,
	autoplaySpeed: 4000,
	slidesToShow: 1,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				speed: 1000,
			}
		},
		{
			breakpoint: 575,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				speed: 1000,
			}
		},
	]
  }
  return (
	  <section className="inner-breeder-area breeder-bg">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-xl-4 col-lg-9 col-md-12 col-sm-9">
              <div className="adoption-content">
                <h5 className="sub-title">Rencontre & Adoption</h5>
                <h2 className="title">Offrez<span>un foyer, vivez</span>un moment de bonheur</h2>
                <p>Adopter l’un de nos chiots, c’est choisir</p>
                <div className="adoption-list">
                  <ul>
                    <li><i className="flaticon-tick" />🐾 un ami loyal,</li>
                    <li><i className="flaticon-tick" />🐾 une relation basée sur la confiance,</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-9 col-md-12 col-sm-9">
              <div className="breeder-info-wrap">
                <div className="row no-gutters justify-content-center">
                  <div className="col-md-6">
                    <Slider className="breeder-active owl-carousel"{...settings}>
                      <div className="breeder-item">
                        <Link to="#">
                          <img src="img/images/breeder_img01.jpg" alt="" />
                        </Link>
                      </div>
                      <div className="breeder-item">
                        <Link to="#">
                          <img src="img/images/breeder_img02.jpg" alt="" />
                        </Link>
                      </div>
                      <div className="breeder-item">
                        <Link to="#">
                          <img src="img/images/breeder_img03.jpg" alt="" />
                        </Link>
                      </div>
                      <div className="breeder-item">
                        <Link to="#">
                          <img src="img/images/breeder_img04.jpg" alt="" />
                        </Link>
                      </div>
                      <div className="breeder-item">
                        <Link to="#">
                          <img src="img/images/breeder_img05.jpg" alt="" />
                        </Link>
                      </div>
                    </Slider>
                  </div>
                  <div className="col-md-6">
                    <div className="breed-services-info" style={{backgroundImage:'url("img/bg/breed_services_bg.jpg")'}}>
                      <h5 className="sub-title">Santé & </h5>
                      <h3 className="title">Bien-être</h3>
                      <p>Nous accordons une attention particulière à la santé, au suivi et au bien-être de nos chiots afin de garantir une adoption responsable.</p>
                      <Link to="#" className="btn">Safi Dog <img src="img/icon/w_pawprint.png" alt="" /></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="counter-area mt-70">
          <HomeCounter/>
        </div>
        </div>
          
      </section>
  )
}

export default AdoptionSlider;
